import styled from 'styled-components';
import { palette } from 'styled-theme';
import { transition } from '../../../settings/style-util';

const MainMenuWrapper = styled.div`
  .isoDashboardMenu {
    background: transparent;
    min-height: 400px;
    width: 100%;

    a {
      text-decoration: none;
      font-weight: 400;
    }

    .ant-menu-item,
    .ant-menu-submenu {
      width: 100%;
      margin: 5px 0;
    }

    > .ant-menu-item:not(.ant-menu-item-selected):hover,
    .ant-menu-item-group-list > .ant-menu-item:not(.ant-menu-item-selected):hover {
      background-color: ${palette('primary', 3)} !important;
      border-left: 4px solid ${palette('primary', 0)};

      svg {
        color: ${palette('primary', 0)};
      }

      .nav-text {
        color: ${palette('primary', 0)};
      }
    }

    .ant-menu-item {
      padding-left: 0 !important;
      padding-right: 14px !important;
      padding-top: 0 !important;
      padding-bottom: 0 !important;
      display: flex;
      align-items: center;
      height: 40px;
      transition: border-color 0.2s, background 0.3s, padding 0.2s;
    }

    .isoMenuHolder {
      display: flex;
      align-items: center;
      padding-left: 12px;
      padding-top: 8px;
      padding-bottom: 8px;
      width: 100%;
      height: 100%;

      svg {
        font-size: 16px;
        color: ${palette('grayscale', 1)};
        margin: ${props => (props['data-rtl'] === 'rtl' ? '0 0 0 16px' : '0 16px 0 0')};
        flex-shrink: 0;
        width: 16px;
        height: 16px;
        transition: color 0.3s cubic-bezier(0.215, 0.61, 0.355, 1);
      }
    }

    .anticon {
      font-size: 18px;
      margin-right: 30px;
      color: inherit;
      ${transition()};
    }

    .nav-text {
      font-size: 14px;
      color: ${palette('grayscale', 0)};
      font-weight: 500;
      line-height: 1.5;
      letter-spacing: 0.24px;
      ${transition()}
      :first-child {
        color: ${palette('grayscale', 5)};
      }
    }

    .nav-tag-new {
      flex-shrink: 0;
      font-size: 10px;
      font-weight: 700;
      line-height: 1;
      letter-spacing: 0.04em;
      text-transform: uppercase;
      color: ${palette('primary', 0)};
      background-color: ${palette('primary', 3)};
      border: 1px solid #c7e5ff;
      border-radius: 9999px;
      padding: 3px 7px;
      margin: ${props => (props['data-rtl'] === 'rtl' ? '0 auto 0 0' : '0 0 0 auto')};
    }
  }

  .ant-menu-submenu {
    border-color: ${palette('grayscale', 5)};
    border-left-width: ${props => (props['data-rtl'] === 'rtl' ? '0' : '4px')};
    border-right-width: ${props => (props['data-rtl'] === 'rtl' ? '4px' : '0')};
    border-top-width: 0;
    border-bottom-width: 0;
    border-style: solid;
    margin: 0;
    transition: border-color 0.2s, background 0.3s;

    .ant-menu-item-selected {
      background-color: ${palette('primary', 3)} !important;
    }
  }

  .ant-menu-submenu.ant-menu-submenu-inline:hover {
    border-color: ${palette('primary', 0)};
    border-left-width: ${props => (props['data-rtl'] === 'rtl' ? '0' : '4px')};
    border-right-width: ${props => (props['data-rtl'] === 'rtl' ? '4px' : '0')};
    border-top-width: 0;
    border-bottom-width: 0;
    border-style: solid;
  }

  .ant-menu-submenu:not(.ant-menu-submenu-open):hover {
    background-color: ${palette('primary', 3)};

    svg {
      color: ${palette('primary', 0)};
    }

    .nav-text {
      color: ${palette('primary', 0)};
    }

    .ant-menu-submenu-title .ant-menu-submenu-arrow {
      &:before,
      &:after {
        background: ${palette('primary', 0)};
      }
    }
  }

  .ant-menu-inline-collapsed .ant-menu-submenu,
  .ant-menu-inline .ant-menu-submenu {
    .ant-menu-item:hover,
    .ant-menu-item-selected {
      border-left: none;

      span a {
        color: ${palette('primary', 0)} !important;
      }
    }
  }

  .ant-menu-inline-collapsed .ant-menu-submenu-selected,
  .ant-menu-inline .ant-menu-submenu-selected {
    border-color: ${palette('primary', 0)};
    border-left-width: ${props => (props['data-rtl'] === 'rtl' ? '0' : '4px')};
    border-right-width: ${props => (props['data-rtl'] === 'rtl' ? '4px' : '0')};
    border-top-width: 0;
    border-bottom-width: 0;
    border-style: solid;

    &:not(.ant-menu-submenu-open) {
      background-color: ${palette('primary', 3)};
    }

    .ant-menu-item:hover,
    .ant-menu-item-selected {
      border-left: none;
    }

    &:hover {
      border-color: ${palette('primary', 0)};
      border-left-width: ${props => (props['data-rtl'] === 'rtl' ? '0' : '4px')};
      border-right-width: ${props => (props['data-rtl'] === 'rtl' ? '4px' : '0')};
      border-top-width: 0;
      border-bottom-width: 0;
      border-style: solid;

      .ant-menu-submenu-title .ant-menu-submenu-arrow {
        &:before,
        &:after {
          background: ${palette('primary', 0)};
        }
      }
    }

    svg {
      color: ${palette('primary', 0)};
    }

    .nav-text {
      color: ${palette('primary', 0)};
    }

    .ant-menu-submenu-title .ant-menu-submenu-arrow {
      &:before,
      &:after {
        background: ${palette('primary', 0)};
      }
    }
  }

  .ant-menu-inline-collapsed .ant-menu-item-selected,
  .ant-menu-inline .ant-menu-item-selected {
    background-color: ${palette('primary', 3)} !important;
    border-color: ${palette('primary', 0)};
    border-left: 4px solid ${palette('primary', 0)};

    svg {
      color: ${palette('primary', 0)};
    }

    .nav-text {
      color: ${palette('primary', 0)};
    }

    .ant-menu-submenu-title .ant-menu-submenu-arrow {
      &:before,
      &:after {
        background: ${palette('primary', 0)};
      }
    }
  }

  .ant-menu-submenu-open {
    background-color: ${palette('grayscale', 4)};
    border-color: ${palette('grayscale', 1)};

    .ant-menu-submenu-title {
      background-color: ${palette('grayscale', 3)};
      margin-bottom: 0;

      svg {
        color: ${palette('grayscale', 1)};
      }

      .nav-text {
        color: ${palette('grayscale', 0)};
      }

      .ant-menu-submenu-arrow {
        &:before,
        &:after {
          background: ${palette('grayscale', 1)};
        }
        transform: rotate(180deg);
      }
    }

    .ant-menu-item {
      > span > a {
        color: ${palette('grayscale', 0)};
      }

      &:hover {
        background-color: ${palette('primary', 3)} !important;
        border-left: none;
      }
    }

    &.ant-menu-submenu-selected {
      .ant-menu-submenu-title {
        background-color: ${palette('primary', 3)};
        border-color: ${palette('primary', 0)};

        svg {
          color: ${palette('primary', 0)};
        }

        .nav-text {
          color: ${palette('primary', 0)};
        }

        :hover {
          svg {
            color: ${palette('primary', 0)};
          }

          .nav-text {
            color: ${palette('primary', 0)};
          }
        }
      }

      .ant-menu-sub {
        .ant-menu-item-disabled {
          & > a {
            color: ${palette('disabledInput', 1)} !important;
          }
        }

        .ant-menu-item-selected span {
          color: ${palette('primary', 0)};
        }
      }
    }
  }

  .ant-menu-submenu {
    &.ant-menu-submenu-active.ant-menu-submenu-open:hover {
      .ant-menu-submenu-arrow {
        &:before,
        &:after {
          background: ${palette('grayscale', 1)};
        }
      }
    }

    > .ant-menu-submenu-title {
      width: 100%;
      display: flex;
      align-items: center;
      padding: 0 17px 0 0 !important;
      transition: border-color 0.2s, background 0.3s, padding 0.2s;

      > span > span {
        display: flex;
        align-items: center;
        padding-left: 0;
      }

      .ant-menu-submenu-arrow {
        left: ${props => (props['data-rtl'] === 'rtl' ? '25px' : 'auto')};
        right: ${props => (props['data-rtl'] === 'rtl' ? 'auto' : '17px')};
        opacity: 1;
        transition: opacity 0.1s 0.2s;

        &:before,
        &:after {
          background-color: ${palette('grayscale', 1)};
          width: 8px;
          ${transition()};
        }

        &:before {
          transform: rotate(-45deg) translateX(3px);
        }

        &:after {
          transform: rotate(45deg) translateX(-3px);
        }
      }
    }

    .ant-menu-inline-collapsed > .ant-menu-item {
      padding-left: 13px;
    }

    .ant-menu-inline,
    .ant-menu-submenu-vertical {
      > li:not(.ant-menu-item-group) {
        padding-left: ${props => (props['data-rtl'] === 'rtl' ? '0px !important' : '44px !important')};
        padding-right: ${props => (props['data-rtl'] === 'rtl' ? '60px !important' : '0px !important')};
        text-align: ${props => (props['data-rtl'] === 'rtl' ? 'right' : 'left')};
        margin: 0;
        color: inherit;
        ${transition()};
      }

      .ant-menu-item-group {
        padding-left: 0;

        .ant-menu-item-group-title {
          padding-left: 100px !important;
        }
        .ant-menu-item-group-list {
          .ant-menu-item {
            padding-left: 125px !important;
          }
        }
      }
    }

    .ant-menu-sub {
      box-shadow: none;
      background-color: transparent !important;
    }
  }

  .ant-menu-inline .ant-menu-submenu {
    padding-bottom: 0;
  }

  .ant-menu-submenu-inline > {
    .ant-menu-submenu-title:after {
      display: none;
    }
  }

  .ant-menu-submenu-vertical {
    > .ant-menu-submenu-title:after {
      display: none;
    }

    .ant-menu-sub {
      background-color: transparent !important;

      .ant-menu-item {
        height: 35px;
      }
    }
  }

  .ant-menu-inline-collapsed {
    > .ant-menu-item {
      padding: 0 !important;
      justify-content: flex-start;

      &:first-child:not(.ant-menu-item-only-child) {
        width: 60%;
        margin: 0 15px;
        border-radius: 50%;

        svg {
          margin-right: 0;
        }
      }

      &:first-child.ant-menu-item-only-child {
        margin-bottom: 0;
      }
    }

    > .ant-menu-submenu > .ant-menu-submenu-title {
      padding: 0 !important;
      justify-content: flex-start;
    }

    .ant-menu-submenu > .ant-menu-submenu-title .ant-menu-submenu-arrow {
      opacity: 0;
      transition: none;
    }

    .isoMenuHolder {
      padding: 0 !important;
      width: 48px;
      justify-content: center;
      margin-left: -4px;

      svg {
        margin: 0 !important;
      }
    }

    .nav-text,
    .nav-tag-new {
      display: none;
    }
  }

  .ant-menu-submenu {
    border-color: ${palette('grayscale', 5)};
    background-color: ${palette('grayscale', 5)};
  }

  .ant-menu-submenu > .ant-menu-submenu-title {
    padding: 0 !important;
    border-color: ${palette('grayscale', 5)};
    margin: 0;
  }

  .ant-menu-item-group {
    .ant-menu-item-group-title {
      color: #908f8f;
      font-size: 12px;
      font-weight: 400;
      height: 24px;
      margin-top: 8px;
      padding: 0 10px 0 14px;
      display: flex;
      align-items: center;
    }

    .ant-menu-item-group-list {
      .ant-menu-item {
        margin: 0;
      }
    }
  }

  .ant-menu-inline-collapsed .ant-menu-item-group {
    .ant-menu-item-group-title {
      padding: 5px;
      display: flex;
      justify-content: center;
      font-size: 0;
      color: transparent;
      height: 11px;
      margin-top: 0;

      &::before {
        content: '';
        display: block;
        width: 32px;
        height: 1px;
        background-color: #eeeeee;
      }
    }
  }
`;

export default MainMenuWrapper;
